var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49.0707,
    height: 49.0707,
    rx: 6.92763,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3417 6.34948C15.5243 6.34949 12.8223 7.49021 10.8301 9.5207C8.83795 11.5512 7.71875 14.3051 7.71875 17.1767C7.71875 20.0482 8.83795 22.8022 10.8301 24.8327C12.8223 26.8632 15.5243 28.0039 18.3417 28.0039L18.3417 17.1767L18.3417 6.34948Z",
    fill: "#646174"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7364 42.6466C33.5538 42.6466 36.2558 41.5059 38.248 39.4754C40.2402 37.4449 41.3594 34.691 41.3594 31.8194C41.3594 28.9478 40.2402 26.1939 38.248 24.1634C36.2558 22.1329 33.5538 20.9922 30.7365 20.9922L30.7364 31.8194L30.7364 42.6466Z",
    fill: "#646174"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7208 18.3358C42.7208 15.5184 41.5801 12.8165 39.5496 10.8243C37.5191 8.83209 34.7652 7.71289 31.8936 7.71289C29.0221 7.71289 26.2681 8.83209 24.2376 10.8243C22.2071 12.8165 21.0664 15.5184 21.0664 18.3358L31.8936 18.3358L42.7208 18.3358Z",
    fill: "#646174"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42371 30.7306C6.4237 33.548 7.56442 36.2499 9.59492 38.2421C11.6254 40.2343 14.3794 41.3535 17.2509 41.3535C20.1225 41.3535 22.8764 40.2343 24.9069 38.2421C26.9374 36.2499 28.0781 33.548 28.0781 30.7306L17.2509 30.7306L6.42371 30.7306Z",
    fill: "#646174"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessTransfer);
export default __webpack_public_path__ + "static/media/Business Transfer.d73524594a163b319948e59a70aca8f1.svg";
export { ForwardRef as ReactComponent };